/*!
 * float-sidebar - Lightweight (2kb gzipped), zero-dependency javascript library for making float sidebars based on the finite state machine
 * @version v1.2.3
 * @link https://github.com/vursen/FloatSidebar.js
 * @author Sergey Vinogradov
 * @license The MIT License (MIT)
 */
/*
!function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.FloatSidebar=n():t.FloatSidebar=n()}(window,(function(){return function(t){var n={};function e(o){if(n[o])return n[o].exports;var i=n[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:o})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(e.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(o,i,function(n){return t[n]}.bind(null,i));return o},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=0)}([function(t,n,e){"use strict";e.r(n);var o,i="START",r="TOP_FIXED",s="UNFIXED",u="BOTTOM_FIXED",a="FINISH";function p(t,n,e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}var c,f=(p(o={},i,(function(t,n){var e=n.$sideInner;e.style.position="absolute",e.style.top="0",e.style.bottom="auto"})),p(o,r,(function(t,n){var e=n.$sideInner;e.style.position="fixed",e.style.top=t.topSpacing+"px",e.style.bottom="auto"})),p(o,s,(function(t,n){var e=n.$sideInner;e.style.position="absolute",e.style.top=t.sideInnerTop-t.startPoint+"px",e.style.bottom="auto"})),p(o,u,(function(t,n){var e=n.$sideInner;e.style.position="fixed",e.style.top="auto",e.style.bottom=t.bottomSpacing+"px"})),p(o,a,(function(t,n){var e=n.$sideInner;e.style.position="absolute",e.style.top="auto",e.style.bottom="0"})),o);function d(t,n,e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}var l=(d(c={},i,[{to:a,when:function(t){return[!0===t.isSideInnerFitsPath,t.viewportTop+t.sideInnerHeight>=t.finishPoint]}},{to:u,when:function(t){return[!0===t.isSideInnerFitsPath,!1===t.isSideInnerFitsViewport,t.viewportBottom>=t.sideInnerBottom+t.bottomSpacing]}},{to:r,when:function(t){return[!0===t.isSideInnerFitsPath,!0===t.isSideInnerFitsViewport,t.viewportTop>=t.startPoint-t.topSpacing]}}]),d(c,r,[{to:i,when:function(t){return[!1===t.isSideInnerFitsPath]}},{to:i,when:function(t){return[t.viewportTop<=t.startPoint-t.topSpacing]}},{to:a,when:function(t){return[t.sideInnerBottom>=t.finishPoint]}},{to:s,when:function(t){return["down"===t.scrollDirection,!1===t.isSideInnerFitsViewport]}}]),d(c,s,[{to:i,when:function(t){return[!1===t.isSideInnerFitsPath]}},{to:r,when:function(t){return[t.viewportTop<=t.sideInnerTop-t.topSpacing]}},{to:r,when:function(t){return[!0===t.isSideInnerFitsViewport,t.viewportBottom>=t.sideInnerBottom+t.bottomSpacing]}},{to:u,when:function(t){return[!1===t.isSideInnerFitsViewport,t.viewportBottom>=t.sideInnerBottom+t.bottomSpacing]}}]),d(c,u,[{to:i,when:function(t){return[!1===t.isSideInnerFitsPath]}},{to:s,when:function(t){return["up"===t.scrollDirection]}},{to:r,when:function(t){return[!0===t.isSideInnerFitsViewport]}},{to:a,when:function(t){return[t.sideInnerBottom>=t.finishPoint]}}]),d(c,a,[{to:i,when:function(t){return[!1===t.isSideInnerFitsPath]}},{to:u,when:function(t){return[t.sideInnerBottom+t.bottomSpacing<=t.finishPoint,t.viewportBottom<=t.finishPoint]}},{to:r,when:function(t){return[t.viewportTop<=t.sideInnerTop-t.topSpacing]}}]),c);var h=function(t){var n=t.actions,e=t.transitions,o=t.initialState;return{findTransitionFor:function(){for(var t=arguments.length,n=Array(t),i=0;i<t;i++)n[i]=arguments[i];return e[o].find((function(t){return t.when.apply(void 0,n).every((function(t){return t}))}))},performTransition:function(t){var e=t.to;return function(){o=e,n[e].apply(n,arguments)}}}};var v=function(t,n){var e=t.getBoundingClientRect();return{top:e.top+n,bottom:e.bottom+n,height:e.height}};var m=function(t,n){var e=n.$viewport,o=n.$relative,i=n.$sideInner,r=n.$sideOuter,s=n.topSpacing,u=n.bottomSpacing,a={},p=function(){var t,n=function(t){var n=t.clientHeight||t.innerHeight,e=t.scrollTop||t.pageYOffset;return{top:e,bottom:e+n,height:n}}(e),p=v(i,n.top),c=v(r,n.top),f=v(o,n.top),d=(t=n.top,a.viewportTop<t?"down":a.viewportTop>t?"up":"notChanged"),l=c.top,h=f.bottom,m=h-l,w=p.height+s+u<n.height,b=p.height<m,g=Math.max(p.height,m);return{startPoint:l,finishPoint:h,topSpacing:s,bottomSpacing:u,scrollDirection:d,isSideInnerFitsPath:b,isSideInnerFitsViewport:w,sideOuterHeight:g,viewportTop:n.top,viewportBottom:n.bottom,sideInnerTop:p.top,sideInnerBottom:p.bottom,sideInnerHeight:p.height}},c=function(t){var n=void 0;return function(){n||(n=requestAnimationFrame((function(){n=null,t()})))}}((function(){var n=p();t(a,n),a=n}));return{start:function(){e.addEventListener("scroll",c),e.addEventListener("resize",c),c()},stop:function(){e.removeEventListener("scroll",c),e.removeEventListener("resize",c)},tick:c}};n.default=function(t){var n=t.viewport||window,e=t.sidebar,o=t.sidebarInner||e.firstElementChild,r=t.relative,s=t.topSpacing||0,u=t.bottomSpacing||0,a=h({actions:f,transitions:l,initialState:i}),p=m((function(t,n){var i=a.findTransitionFor(n);i&&a.performTransition(i)(n,{$sideInner:o,$sideOuter:e,$relative:r}),c(t,n)}),{$viewport:n,$sideOuter:e,$sideInner:o,$relative:r,topSpacing:s,bottomSpacing:u}),c=function(t,n){Math.abs((t.sideOuterHeight||0)-n.sideOuterHeight)>=1&&(e.style.height=n.sideOuterHeight+"px")};return requestAnimationFrame((function(){e.style.willChange="height",o.style.width="inherit",o.style.transform="translateZ(0)",o.style.willChange="transform",p.start()})),{forceUpdate:function(){p.tick()},destroy:function(){p.stop()}}}}]).default}));
*/

/* Resize Sensor for sticky-sidebar */
'use strict';

/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */
(function (root, factory) {
   if (typeof define === "function" && define.amd) {
      define(factory);
   } else if (typeof exports === "object") {
      module.exports = factory();
   } else {
      root.ResizeSensor = factory();
   }
}(typeof window !== 'undefined' ? window : this, function () {

   // Make sure it does not throw in a SSR (Server Side Rendering) situation
   if (typeof window === "undefined") {
      return null;
   }
   // https://github.com/Semantic-Org/Semantic-UI/issues/3855
   // https://github.com/marcj/css-element-queries/issues/257
   var globalWindow = typeof window != 'undefined' && window.Math == Math
      ? window
      : typeof self != 'undefined' && self.Math == Math
         ? self
         : Function('return this')();
   // Only used for the dirty checking, so the event callback count is limited to max 1 call per fps per sensor.
   // In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
   // would generate too many unnecessary events.
   var requestAnimationFrame = globalWindow.requestAnimationFrame ||
      globalWindow.mozRequestAnimationFrame ||
      globalWindow.webkitRequestAnimationFrame ||
      function (fn) {
         return globalWindow.setTimeout(fn, 20);
      };

   var cancelAnimationFrame = globalWindow.cancelAnimationFrame ||
      globalWindow.mozCancelAnimationFrame ||
      globalWindow.webkitCancelAnimationFrame ||
      function (timer) {
         globalWindow.clearTimeout(timer);
      };

   /**
    * Iterate over each of the provided element(s).
    *
    * @param {HTMLElement|HTMLElement[]} elements
    * @param {Function}                  callback
    */
   function forEachElement(elements, callback) {
      var elementsType = Object.prototype.toString.call(elements);
      var isCollectionTyped = ('[object Array]' === elementsType
         || ('[object NodeList]' === elementsType)
         || ('[object HTMLCollection]' === elementsType)
         || ('[object Object]' === elementsType)
         || ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
         || ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
      );
      var i = 0, j = elements.length;
      if (isCollectionTyped) {
         for (; i < j; i++) {
            callback(elements[i]);
         }
      } else {
         callback(elements);
      }
   }

   /**
   * Get element size
   * @param {HTMLElement} element
   * @returns {Object} {width, height}
   */
   function getElementSize(element) {
      if (!element.getBoundingClientRect) {
         return {
            width: element.offsetWidth,
            height: element.offsetHeight
         }
      }

      var rect = element.getBoundingClientRect();
      return {
         width: Math.round(rect.width),
         height: Math.round(rect.height)
      }
   }

   /**
    * Apply CSS styles to element.
    *
    * @param {HTMLElement} element
    * @param {Object} style
    */
   function setStyle(element, style) {
      Object.keys(style).forEach(function (key) {
         element.style[key] = style[key];
      });
   }

   /**
    * Class for dimension change detection.
    *
    * @param {Element|Element[]|Elements|jQuery} element
    * @param {Function} callback
    *
    * @constructor
    */
   var ResizeSensor = function (element, callback) {
      //Is used when checking in reset() only for invisible elements
      var lastAnimationFrameForInvisibleCheck = 0;

      /**
       *
       * @constructor
       */
      function EventQueue() {
         var q = [];
         this.add = function (ev) {
            q.push(ev);
         };

         var i, j;
         this.call = function (sizeInfo) {
            for (i = 0, j = q.length; i < j; i++) {
               q[i].call(this, sizeInfo);
            }
         };

         this.remove = function (ev) {
            var newQueue = [];
            for (i = 0, j = q.length; i < j; i++) {
               if (q[i] !== ev) newQueue.push(q[i]);
            }
            q = newQueue;
         };

         this.length = function () {
            return q.length;
         }
      }

      /**
       *
       * @param {HTMLElement} element
       * @param {Function}    resized
       */
      function attachResizeEvent(element, resized) {
         if (!element) return;
         if (element.resizedAttached) {
            element.resizedAttached.add(resized);
            return;
         }

         element.resizedAttached = new EventQueue();
         element.resizedAttached.add(resized);

         element.resizeSensor = document.createElement('div');
         element.resizeSensor.dir = 'ltr';
         element.resizeSensor.className = 'resize-sensor';

         var style = {
            pointerEvents: 'none',
            position: 'absolute',
            left: '0px',
            top: '0px',
            right: '0px',
            bottom: '0px',
            overflow: 'hidden',
            zIndex: '-1',
            visibility: 'hidden',
            maxWidth: '100%'
         };
         var styleChild = {
            position: 'absolute',
            left: '0px',
            top: '0px',
            transition: '0s',
         };

         setStyle(element.resizeSensor, style);

         var expand = document.createElement('div');
         expand.className = 'resize-sensor-expand';
         setStyle(expand, style);

         var expandChild = document.createElement('div');
         setStyle(expandChild, styleChild);
         expand.appendChild(expandChild);

         var shrink = document.createElement('div');
         shrink.className = 'resize-sensor-shrink';
         setStyle(shrink, style);

         var shrinkChild = document.createElement('div');
         setStyle(shrinkChild, styleChild);
         setStyle(shrinkChild, { width: '200%', height: '200%' });
         shrink.appendChild(shrinkChild);

         element.resizeSensor.appendChild(expand);
         element.resizeSensor.appendChild(shrink);
         element.appendChild(element.resizeSensor);

         var computedStyle = window.getComputedStyle(element);
         var position = computedStyle ? computedStyle.getPropertyValue('position') : null;
         if ('absolute' !== position && 'relative' !== position && 'fixed' !== position && 'sticky' !== position) {
            element.style.position = 'relative';
         }

         var dirty = false;

         //last request animation frame id used in onscroll event
         var rafId = 0;
         var size = getElementSize(element);
         var lastWidth = 0;
         var lastHeight = 0;
         var initialHiddenCheck = true;
         lastAnimationFrameForInvisibleCheck = 0;

         var resetExpandShrink = function () {
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            expandChild.style.width = (width + 10) + 'px';
            expandChild.style.height = (height + 10) + 'px';

            expand.scrollLeft = width + 10;
            expand.scrollTop = height + 10;

            shrink.scrollLeft = width + 10;
            shrink.scrollTop = height + 10;
         };

         var reset = function () {
            // Check if element is hidden
            if (initialHiddenCheck) {
               var invisible = element.offsetWidth === 0 && element.offsetHeight === 0;
               if (invisible) {
                  // Check in next frame
                  if (!lastAnimationFrameForInvisibleCheck) {
                     lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function () {
                        lastAnimationFrameForInvisibleCheck = 0;
                        reset();
                     });
                  }

                  return;
               } else {
                  // Stop checking
                  initialHiddenCheck = false;
               }
            }

            resetExpandShrink();
         };
         element.resizeSensor.resetSensor = reset;

         var onResized = function () {
            rafId = 0;

            if (!dirty) return;

            lastWidth = size.width;
            lastHeight = size.height;

            if (element.resizedAttached) {
               element.resizedAttached.call(size);
            }
         };

         var onScroll = function () {
            size = getElementSize(element);
            dirty = size.width !== lastWidth || size.height !== lastHeight;

            if (dirty && !rafId) {
               rafId = requestAnimationFrame(onResized);
            }

            reset();
         };

         var addEvent = function (el, name, cb) {
            if (el.attachEvent) {
               el.attachEvent('on' + name, cb);
            } else {
               el.addEventListener(name, cb);
            }
         };

         addEvent(expand, 'scroll', onScroll);
         addEvent(shrink, 'scroll', onScroll);

         // Fix for custom Elements and invisible elements
         lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function () {
            lastAnimationFrameForInvisibleCheck = 0;
            reset();
         });
      }

      forEachElement(element, function (elem) {
         attachResizeEvent(elem, callback);
      });

      this.detach = function (ev) {
         // clean up the unfinished animation frame to prevent a potential endless requestAnimationFrame of reset
         if (lastAnimationFrameForInvisibleCheck) {
            cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
            lastAnimationFrameForInvisibleCheck = 0;
         }
         ResizeSensor.detach(element, ev);
      };

      this.reset = function () {
         //To prevent invoking element.resizeSensor.resetSensor if it's undefined
         if (element.resizeSensor.resetSensor) {
            element.resizeSensor.resetSensor();
         }
      };
   };

   ResizeSensor.reset = function (element) {
      forEachElement(element, function (elem) {
         //To prevent invoking element.resizeSensor.resetSensor if it's undefined
         if (element.resizeSensor.resetSensor) {
            elem.resizeSensor.resetSensor();
         }
      });
   };

   ResizeSensor.detach = function (element, ev) {
      forEachElement(element, function (elem) {
         if (!elem) return;
         if (elem.resizedAttached && typeof ev === "function") {
            elem.resizedAttached.remove(ev);
            if (elem.resizedAttached.length()) return;
         }
         if (elem.resizeSensor) {
            if (elem.contains(elem.resizeSensor)) {
               elem.removeChild(elem.resizeSensor);
            }
            delete elem.resizeSensor;
            delete elem.resizedAttached;
         }
      });
   };

   if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function (mutations) {
         for (var i in mutations) {
            if (mutations.hasOwnProperty(i)) {
               var items = mutations[i].addedNodes;
               for (var j = 0; j < items.length; j++) {
                  if (items[j].resizeSensor) {
                     ResizeSensor.reset(items[j]);
                  }
               }
            }
         }
      });

      document.addEventListener("DOMContentLoaded", function (event) {
         observer.observe(document.body, {
            childList: true,
            subtree: true,
         });
      });
   }

   return ResizeSensor;

}));

/**
 * sticky-sidebar - A JavaScript plugin for making smart and high performance.
 * @version v3.3.1
 * @link https://github.com/abouolia/sticky-sidebar
 * @author Ahmed Bouhuolia
 * @license The MIT License (MIT)
**/
!function (t, e) { "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.StickySidebar = e() }(this, function () { "use strict"; "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self; function t(t) { return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t } function e(t, e) { return t(e = { exports: {} }, e.exports), e.exports } var i = e(function (t, e) { (function (t) { Object.defineProperty(t, "__esModule", { value: !0 }); var l, n, e = function () { function n(t, e) { for (var i = 0; i < e.length; i++) { var n = e[i]; n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n) } } return function (t, e, i) { return e && n(t.prototype, e), i && n(t, i), t } }(), i = (l = ".stickySidebar", n = { topSpacing: 0, bottomSpacing: 0, containerSelector: !1, innerWrapperSelector: ".inner-wrapper-sticky", stickyClass: "is-affixed", resizeSensor: !0, minWidth: !1 }, function () { function c(t) { var e = this, i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}; if (function (t, e) { if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function") }(this, c), this.options = c.extend(n, i), this.sidebar = "string" == typeof t ? document.querySelector(t) : t, void 0 === this.sidebar) throw new Error("There is no specific sidebar element."); this.sidebarInner = !1, this.container = this.sidebar.parentElement, this.affixedType = "STATIC", this.direction = "down", this.support = { transform: !1, transform3d: !1 }, this._initialized = !1, this._reStyle = !1, this._breakpoint = !1, this.dimensions = { translateY: 0, maxTranslateY: 0, topSpacing: 0, lastTopSpacing: 0, bottomSpacing: 0, lastBottomSpacing: 0, sidebarHeight: 0, sidebarWidth: 0, containerTop: 0, containerHeight: 0, viewportHeight: 0, viewportTop: 0, lastViewportTop: 0 }, ["handleEvent"].forEach(function (t) { e[t] = e[t].bind(e) }), this.initialize() } return e(c, [{ key: "initialize", value: function () { var i = this; if (this._setSupportFeatures(), this.options.innerWrapperSelector && (this.sidebarInner = this.sidebar.querySelector(this.options.innerWrapperSelector), null === this.sidebarInner && (this.sidebarInner = !1)), !this.sidebarInner) { var t = document.createElement("div"); for (t.setAttribute("class", "inner-wrapper-sticky"), this.sidebar.appendChild(t); this.sidebar.firstChild != t;)t.appendChild(this.sidebar.firstChild); this.sidebarInner = this.sidebar.querySelector(".inner-wrapper-sticky") } if (this.options.containerSelector) { var e = document.querySelectorAll(this.options.containerSelector); if ((e = Array.prototype.slice.call(e)).forEach(function (t, e) { t.contains(i.sidebar) && (i.container = t) }), !e.length) throw new Error("The container does not contains on the sidebar.") } "function" != typeof this.options.topSpacing && (this.options.topSpacing = parseInt(this.options.topSpacing) || 0), "function" != typeof this.options.bottomSpacing && (this.options.bottomSpacing = parseInt(this.options.bottomSpacing) || 0), this._widthBreakpoint(), this.calcDimensions(), this.stickyPosition(), this.bindEvents(), this._initialized = !0 } }, { key: "bindEvents", value: function () { window.addEventListener("resize", this, { passive: !0, capture: !1 }), window.addEventListener("scroll", this, { passive: !0, capture: !1 }), this.sidebar.addEventListener("update" + l, this), this.options.resizeSensor && "undefined" != typeof ResizeSensor && (new ResizeSensor(this.sidebarInner, this.handleEvent), new ResizeSensor(this.container, this.handleEvent)) } }, { key: "handleEvent", value: function (t) { this.updateSticky(t) } }, { key: "calcDimensions", value: function () { if (!this._breakpoint) { var t = this.dimensions; t.containerTop = c.offsetRelative(this.container).top, t.containerHeight = this.container.clientHeight, t.containerBottom = t.containerTop + t.containerHeight, t.sidebarHeight = this.sidebarInner.offsetHeight, t.sidebarWidth = this.sidebarInner.offsetWidth, t.viewportHeight = window.innerHeight, t.maxTranslateY = t.containerHeight - t.sidebarHeight, this._calcDimensionsWithScroll() } } }, { key: "_calcDimensionsWithScroll", value: function () { var t = this.dimensions; t.sidebarLeft = c.offsetRelative(this.sidebar).left, t.viewportTop = document.documentElement.scrollTop || document.body.scrollTop, t.viewportBottom = t.viewportTop + t.viewportHeight, t.viewportLeft = document.documentElement.scrollLeft || document.body.scrollLeft, t.topSpacing = this.options.topSpacing, t.bottomSpacing = this.options.bottomSpacing, "function" == typeof t.topSpacing && (t.topSpacing = parseInt(t.topSpacing(this.sidebar)) || 0), "function" == typeof t.bottomSpacing && (t.bottomSpacing = parseInt(t.bottomSpacing(this.sidebar)) || 0), "VIEWPORT-TOP" === this.affixedType ? t.topSpacing < t.lastTopSpacing && (t.translateY += t.lastTopSpacing - t.topSpacing, this._reStyle = !0) : "VIEWPORT-BOTTOM" === this.affixedType && t.bottomSpacing < t.lastBottomSpacing && (t.translateY += t.lastBottomSpacing - t.bottomSpacing, this._reStyle = !0), t.lastTopSpacing = t.topSpacing, t.lastBottomSpacing = t.bottomSpacing } }, { key: "isSidebarFitsViewport", value: function () { var t = this.dimensions, e = "down" === this.scrollDirection ? t.lastBottomSpacing : t.lastTopSpacing; return this.dimensions.sidebarHeight + e < this.dimensions.viewportHeight } }, { key: "observeScrollDir", value: function () { var t = this.dimensions; if (t.lastViewportTop !== t.viewportTop) { var e = "down" === this.direction ? Math.min : Math.max; t.viewportTop === e(t.viewportTop, t.lastViewportTop) && (this.direction = "down" === this.direction ? "up" : "down") } } }, { key: "getAffixType", value: function () { this._calcDimensionsWithScroll(); var t = this.dimensions, e = t.viewportTop + t.topSpacing, i = this.affixedType; return e <= t.containerTop || t.containerHeight <= t.sidebarHeight ? (t.translateY = 0, i = "STATIC") : i = "up" === this.direction ? this._getAffixTypeScrollingUp() : this._getAffixTypeScrollingDown(), t.translateY = Math.max(0, t.translateY), t.translateY = Math.min(t.containerHeight, t.translateY), t.translateY = Math.round(t.translateY), t.lastViewportTop = t.viewportTop, i } }, { key: "_getAffixTypeScrollingDown", value: function () { var t = this.dimensions, e = t.sidebarHeight + t.containerTop, i = t.viewportTop + t.topSpacing, n = t.viewportBottom - t.bottomSpacing, o = this.affixedType; return this.isSidebarFitsViewport() ? t.sidebarHeight + i >= t.containerBottom ? (t.translateY = t.containerBottom - e, o = "CONTAINER-BOTTOM") : i >= t.containerTop && (t.translateY = i - t.containerTop, o = "VIEWPORT-TOP") : t.containerBottom <= n ? (t.translateY = t.containerBottom - e, o = "CONTAINER-BOTTOM") : e + t.translateY <= n ? (t.translateY = n - e, o = "VIEWPORT-BOTTOM") : t.containerTop + t.translateY <= i && 0 !== t.translateY && t.maxTranslateY !== t.translateY && (o = "VIEWPORT-UNBOTTOM"), o } }, { key: "_getAffixTypeScrollingUp", value: function () { var t = this.dimensions, e = t.sidebarHeight + t.containerTop, i = t.viewportTop + t.topSpacing, n = t.viewportBottom - t.bottomSpacing, o = this.affixedType; return i <= t.translateY + t.containerTop ? (t.translateY = i - t.containerTop, o = "VIEWPORT-TOP") : t.containerBottom <= n ? (t.translateY = t.containerBottom - e, o = "CONTAINER-BOTTOM") : this.isSidebarFitsViewport() || t.containerTop <= i && 0 !== t.translateY && t.maxTranslateY !== t.translateY && (o = "VIEWPORT-UNBOTTOM"), o } }, { key: "_getStyle", value: function (t) { if (void 0 !== t) { var e = { inner: {}, outer: {} }, i = this.dimensions; switch (t) { case "VIEWPORT-TOP": e.inner = { position: "fixed", top: i.topSpacing, left: i.sidebarLeft - i.viewportLeft, width: i.sidebarWidth }; break; case "VIEWPORT-BOTTOM": e.inner = { position: "fixed", top: "auto", left: i.sidebarLeft, bottom: i.bottomSpacing, width: i.sidebarWidth }; break; case "CONTAINER-BOTTOM": case "VIEWPORT-UNBOTTOM": var n = this._getTranslate(0, i.translateY + "px"); e.inner = n ? { transform: n } : { position: "absolute", top: i.translateY, width: i.sidebarWidth } }switch (t) { case "VIEWPORT-TOP": case "VIEWPORT-BOTTOM": case "VIEWPORT-UNBOTTOM": case "CONTAINER-BOTTOM": e.outer = { height: i.sidebarHeight, position: "relative" } }return e.outer = c.extend({ height: "", position: "" }, e.outer), e.inner = c.extend({ position: "relative", top: "", left: "", bottom: "", width: "", transform: "" }, e.inner), e } } }, { key: "stickyPosition", value: function (t) { if (!this._breakpoint) { t = this._reStyle || t || !1, this.options.topSpacing, this.options.bottomSpacing; var e = this.getAffixType(), i = this._getStyle(e); if ((this.affixedType != e || t) && e) { var n = "affix." + e.toLowerCase().replace("viewport-", "") + l; for (var o in c.eventTrigger(this.sidebar, n), "STATIC" === e ? c.removeClass(this.sidebar, this.options.stickyClass) : c.addClass(this.sidebar, this.options.stickyClass), i.outer) { var s = "number" == typeof i.outer[o] ? "px" : ""; this.sidebar.style[o] = i.outer[o] + s } for (var r in i.inner) { var a = "number" == typeof i.inner[r] ? "px" : ""; this.sidebarInner.style[r] = i.inner[r] + a } var p = "affixed." + e.toLowerCase().replace("viewport-", "") + l; c.eventTrigger(this.sidebar, p) } else this._initialized && (this.sidebarInner.style.left = i.inner.left); this.affixedType = e } } }, { key: "_widthBreakpoint", value: function () { window.innerWidth <= this.options.minWidth ? (this._breakpoint = !0, this.affixedType = "STATIC", this.sidebar.removeAttribute("style"), c.removeClass(this.sidebar, this.options.stickyClass), this.sidebarInner.removeAttribute("style")) : this._breakpoint = !1 } }, { key: "updateSticky", value: function () { var t, e = this, i = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}; this._running || (this._running = !0, t = i.type, requestAnimationFrame(function () { switch (t) { case "scroll": e._calcDimensionsWithScroll(), e.observeScrollDir(), e.stickyPosition(); break; case "resize": default: e._widthBreakpoint(), e.calcDimensions(), e.stickyPosition(!0) }e._running = !1 })) } }, { key: "_setSupportFeatures", value: function () { var t = this.support; t.transform = c.supportTransform(), t.transform3d = c.supportTransform(!0) } }, { key: "_getTranslate", value: function () { var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0, e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0; return this.support.transform3d ? "translate3d(" + t + ", " + e + ", " + i + ")" : !!this.support.translate && "translate(" + t + ", " + e + ")" } }, { key: "destroy", value: function () { window.removeEventListener("resize", this, { capture: !1 }), window.removeEventListener("scroll", this, { capture: !1 }), this.sidebar.classList.remove(this.options.stickyClass), this.sidebar.style.minHeight = "", this.sidebar.removeEventListener("update" + l, this); var t = { inner: {}, outer: {} }; for (var e in t.inner = { position: "", top: "", left: "", bottom: "", width: "", transform: "" }, t.outer = { height: "", position: "" }, t.outer) this.sidebar.style[e] = t.outer[e]; for (var i in t.inner) this.sidebarInner.style[i] = t.inner[i]; this.options.resizeSensor && "undefined" != typeof ResizeSensor && (ResizeSensor.detach(this.sidebarInner, this.handleEvent), ResizeSensor.detach(this.container, this.handleEvent)) } }], [{ key: "supportTransform", value: function (t) { var i = !1, e = t ? "perspective" : "transform", n = e.charAt(0).toUpperCase() + e.slice(1), o = document.createElement("support").style; return (e + " " + ["Webkit", "Moz", "O", "ms"].join(n + " ") + n).split(" ").forEach(function (t, e) { if (void 0 !== o[t]) return i = t, !1 }), i } }, { key: "eventTrigger", value: function (t, e, i) { try { var n = new CustomEvent(e, { detail: i }) } catch (t) { (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, i) } t.dispatchEvent(n) } }, { key: "extend", value: function (t, e) { var i = {}; for (var n in t) void 0 !== e[n] ? i[n] = e[n] : i[n] = t[n]; return i } }, { key: "offsetRelative", value: function (t) { var e = { left: 0, top: 0 }; do { var i = t.offsetTop, n = t.offsetLeft; isNaN(i) || (e.top += i), isNaN(n) || (e.left += n), t = "BODY" === t.tagName ? t.parentElement : t.offsetParent } while (t); return e } }, { key: "addClass", value: function (t, e) { c.hasClass(t, e) || (t.classList ? t.classList.add(e) : t.className += " " + e) } }, { key: "removeClass", value: function (t, e) { c.hasClass(t, e) && (t.classList ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)", "gi"), " ")) } }, { key: "hasClass", value: function (t, e) { return t.classList ? t.classList.contains(e) : new RegExp("(^| )" + e + "( |$)", "gi").test(t.className) } }, { key: "defaults", get: function () { return n } }]), c }()); t.default = i, window.StickySidebar = i })(e) }); return t(i), t(e(function (t, e) { (function (t) { var e, s = (e = t) && e.__esModule ? e : { default: e }; !function () { if ("undefined" != typeof window) { var n = window.$ || window.jQuery || window.Zepto, o = "stickySidebar"; if (n) { n.fn.stickySidebar = function (i) { return this.each(function () { var t = n(this), e = n(this).data(o); if (e || (e = new s.default(this, "object" == typeof i && i), t.data(o, e)), "string" == typeof i) { if (void 0 === e[i] && -1 === ["destroy", "updateSticky"].indexOf(i)) throw new Error('No method named "' + i + '"'); e[i]() } }) }, n.fn.stickySidebar.Constructor = s.default; var t = n.fn.stickySidebar; n.fn.stickySidebar.noConflict = function () { return n.fn.stickySidebar = t, this } } } }() })(i) })) });

//body scroll lock https://www.npmjs.com/package/body-scroll-lock
!function (e, o) { if ("function" == typeof define && define.amd) define(["exports"], o); else if ("undefined" != typeof exports) o(exports); else { var t = {}; o(t), e.bodyScrollLock = t } }(this, function (exports) { "use strict"; Object.defineProperty(exports, "__esModule", { value: !0 }); var t = !1; if ("undefined" != typeof window) { var e = { get passive() { t = !0 } }; window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e) } function l(o) { return c.some(function (e) { return !(!e.options.allowTouchMove || !e.options.allowTouchMove(o)) }) } function d(e) { var o = e || window.event; return !!l(o.target) || (1 < o.touches.length || (o.preventDefault && o.preventDefault(), !1)) } function n() { void 0 !== v && (document.body.style.paddingRight = v, v = void 0), void 0 !== s && (document.body.style.overflow = s, s = void 0) } var i = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), c = [], a = !1, u = -1, s = void 0, v = void 0; exports.disableBodyScroll = function (r, e) { if (r) { if (!c.some(function (e) { return e.targetElement === r })) { var o = { targetElement: r, options: e || {} }; c = [].concat(function (e) { if (Array.isArray(e)) { for (var o = 0, t = Array(e.length); o < e.length; o++)t[o] = e[o]; return t } return Array.from(e) }(c), [o]), i ? (r.ontouchstart = function (e) { 1 === e.targetTouches.length && (u = e.targetTouches[0].clientY) }, r.ontouchmove = function (e) { var o, t, n, i; 1 === e.targetTouches.length && (t = r, i = (o = e).targetTouches[0].clientY - u, l(o.target) || (t && 0 === t.scrollTop && 0 < i || (n = t) && n.scrollHeight - n.scrollTop <= n.clientHeight && i < 0 ? d(o) : o.stopPropagation())) }, a || (document.addEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !0)) : function (e) { if (void 0 === v) { var o = !!e && !0 === e.reserveScrollBarGap, t = window.innerWidth - document.documentElement.clientWidth; o && 0 < t && (v = document.body.style.paddingRight, document.body.style.paddingRight = t + "px") } void 0 === s && (s = document.body.style.overflow, document.body.style.overflow = "hidden") }(e) } } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.") }, exports.clearAllBodyScrollLocks = function () { i ? (c.forEach(function (e) { e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null }), a && (document.removeEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !1), u = -1) : n(), c = [] }, exports.enableBodyScroll = function (o) { o ? (c = c.filter(function (e) { return e.targetElement !== o }), i ? (o.ontouchstart = null, o.ontouchmove = null, a && 0 === c.length && (document.removeEventListener("touchmove", d, t ? { passive: !1 } : void 0), a = !1)) : c.length || n()) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.") } });


/*
Debounce function
*/
function debounce(func, wait, immediate) {
   var timeout;
   return function () {
      var context = this,
         args = arguments;
      var later = function () {
         timeout = null;
         if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
   };
}


/* Sticky Sidebar */
$(document).ready(function () {
   // let sidebar = document.querySelector(".product-v2--sidebar");
   // let relative = document.querySelector(".product-v2--main");
   // let floatSidebar;

   if ($(window).width() > 900) {
      //console.log('enable sticky sidebar');
      $('.product-v2--form').stickySidebar({
         topSpacing: 100,
         bottomSpacing: 60,
         containerSelector: '.product-v2--main',
         innerWrapperSelector: '.product-v2--sidebar',
         resizeSensor: true
      });
      // floatSidebar = FloatSidebar({
      //   sidebar,
      //   relative,
      //   topSpacing: 100,
      //   bottomSpacing: 0,
      // });
   }

   var resizeSidebar = debounce(function () {
      // floatSidebar.forceUpdate();
      //floatSidebar.updateSticky();
      // console.log('debounce');
      if ($(window).width() < 901) {
         // floatSidebar.destroy();
         // console.log('less than 901');
         $('.product-v2--form').stickySidebar('destroy');
         // floatSidebar.destroy();
      } else {
         // console.log('bigger than 901');
         $('.product-v2--form').stickySidebar('updateSticky');
      }
   }, 250);

   window.addEventListener("resize", resizeSidebar);
});


/* Accordion

let copyOpen = "accordion__box--open";
let titles = document.querySelectorAll(".js-title");

// Inicializar todos los acordeones como abiertos
document.querySelectorAll('.accordion__box').forEach(panel => {
   openItem(panel);
});

for (let i = 0; i < titles.length; i++) {
   titles[i].addEventListener("click", toggleItem, false);
}

function toggleItem(e) {
   let panel = e.target.nextElementSibling;
   if (panel.classList.contains(copyOpen)) {
      closeItem(panel);
   } else {
      openItem(panel);
   }

   if ($(window).width() >= 901) {
      //$('.product-v2--form').stickySidebar('updateSticky');
   }
}

function closeItem(panel) {
   panel.classList.remove(copyOpen);
   panel.style.maxHeight = 0;
   panel.style.padding = "0";
   panel.style.borderColor = "#fff";
   panel.previousElementSibling.classList.remove("accordion__active");
   setTimeout(() => {
      const scrollPosition = panel.getBoundingClientRect().top + window.pageYOffset - 300;
      window.scrollTo({
         top: scrollPosition,
         behavior: 'smooth'
      });
   }, 1); // 1000 milisegundos = 1 segundo
}

function openItem(panel) {
   panel.classList.add(copyOpen);
   panel.style.maxHeight = panel.scrollHeight + "px";
   panel.style.padding = "0";
   panel.style.borderColor = "#E7E7E7";
   panel.previousElementSibling.classList.add("accordion__active");
}
 */
/* Open the first accordion only on viewport > 768

let defaultPanel = document.querySelector(".accordion__box");
if (defaultPanel) {
   defaultPanel.classList.remove(copyOpen);
   setTimeout(openItem, 1000, defaultPanel);
}
 */
/* End  */

/* Button-to-the top */

const btn = $("#btn-top");

btn.on("click", function (e) {
   e.preventDefault();
   $("html, body").animate({ scrollTop: 0 }, "300");
});

/* end */

/* Modal*/

// Get the modal
const modal = document.getElementById("modal__size");

// Get the button that opens the modal
const sizeGuideBtn = document.getElementById("size-guide-btn");
const sizeGuideBtnReviews = document.getElementById("size-guide-btn--reviews");
const sizeGuideLink = document.getElementById("size-guide-link");

// When the user clicks the button, open the modal
// sizeGuideLink.onclick = function () {
//   document.querySelector('html').classList.add('unscrollable');
//   modal.style.display = "block";
// };
if (sizeGuideBtn != null) {
   sizeGuideBtn.onclick = function () {
      document.querySelector('html').classList.add('unscrollable');
      modal.style.display = "block";
   };
}

if (sizeGuideBtnReviews != null) {
   sizeGuideBtnReviews.onclick = function () {
      document.querySelector('html').classList.add('unscrollable');
      modal.style.display = "block";
   };
}


// When the user clicks on <span> (x), close the modal
const span = document.getElementById("btn-close");
span.onclick = function () {
   document.querySelector('html').classList.remove('unscrollable');
   modal.style.display = "none";
};

const footerCloseBtn = document.getElementById("btn-footer-close");
footerCloseBtn.onclick = function () {
   document.querySelector('html').classList.remove('unscrollable');
   modal.style.display = "none";
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
   if (event.target == modal) {
      document.querySelector('html').classList.remove('unscrollable');
      modal.style.display = "none";
   }
};

/* Tabs  */

function initTab(elem) {
   document.addEventListener("click", function (e) {
      if (!e.target.matches(elem + " .btn__tab")) return;
      else {
         if (!e.target.classList.contains("active")) {
            findActiveElementAndRemoveIt(elem + " .btn__tab");
            findActiveElementAndRemoveIt(elem + " .tab__content--main");
            e.target.classList.add("active");
            setTimeout(function () {
               var panel = document.querySelectorAll(
                  elem + " .tab__content--main." + e.target.dataset.name
               );
               Array.prototype.forEach.call(panel, function (el) {
                  el.classList.add("active");
               });
            }, 100);
         }
      }
   });
}

function findActiveElementAndRemoveIt(elem) {
   var elementList = document.querySelectorAll(elem);
   Array.prototype.forEach.call(elementList, function (e) {
      e.classList.remove("active");
   });
}

initTab(".tabs");

/* end */

/* Collapse for Reviews */

const triggers = Array.from(
   document.querySelectorAll(['[data-toggle="collapse"]'])
);

window.addEventListener(
   "click",
   (evt) => {
      const element = evt.target;
      if (triggers.includes(element)) {
         const selector = element.getAttribute("data-target");
         collapse(selector, "toggle");
      }
   },
   false
);

const fnmap = {
   toggle: "toggle",
   show: "add",
   hide: "remove",
};
const collapse = (selector, cmd) => {
   const targets = Array.from(document.querySelectorAll(selector));
   targets.forEach((target) => {
      target.classList[fnmap[cmd]]("show");
   });
};

//Scroll
$(document).ready(function () {
   $(".product-v2--reviews a").on("click", function (event) {
       if (this.hash !== "") {
           event.preventDefault();
           var hash = this.hash;

           $("html, body").animate({
               scrollTop: $(hash).offset().top
           }, 600, function () {
               window.location.hash = hash;

           });
       }
   });
});
/* End */

/* Complete the look */

$(document).ready(function () {
   $(".product-v2--look-slide").slick({
      dots: true,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      centerMode: false,
      centerPadding: "0",
      infinite: false,
      prevArrow: $(".product-v2--complete-look-header .look-carousel__prev"),
      nextArrow: $(".product-v2--complete-look-header .look-carousel__next"),
      responsive: [
         {
            breakpoint: 426,
            settings: {
               dots: false,
               slidesToShow: 1,
               slidesToScroll: 1,
            },
         },
      ],
   });
});



/* You may like*/

$(document).ready(function () {
   $(".product-v2--like-carousel").slick({
      dots: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: "0",
      infinite: false,
      prevArrow: $(".product-v2--like-header .like-carousel__prev"),
      nextArrow: $(".product-v2--like-header .like-carousel__next"),
      responsive: [
         {
            breakpoint: 1024,
            settings: {
               slidesToShow: 3.5,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 600,
            settings: {
               slidesToShow: 3.5,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 550,
            settings: {
               slidesToShow: 2.5,
               slidesToScroll: 1,
            },
         },
      ],
   });
});

/* Gallery responsive */
function initSlickGallery() {
   const $gallery = $(".product-v2--gallery-grid");
 
   if ($gallery.length && !$gallery.hasClass("slick-initialized")) {
     $gallery
       .on("init", function (event, slick, direction) {
         slick.slickFilter(":not(.disabled-item)");
       })
       .slick({
         dots: true,
         appendDots: $(".slick-slider-dots"),
         arrows: false,
         slidesToShow: 1,
         slidesToScroll: 1,
         mobileFirst: true,
         infinite: true,
         responsive: [
           {
             breakpoint: 900,
             settings: "unslick",
           },
         ],
       })
       .on("afterChange", function (event, slick, currentSlide) {
         const $video = $(slick.$slides.get(currentSlide)).find("video").get(0);
         if ($video) {
           $video.play();
         }
       });
   }
 }
 

 document.addEventListener("DOMContentLoaded", function () {
   setTimeout(initSlickGallery, 300); 
 });
 
 document.addEventListener("shopify:section:load", function () {
   setTimeout(initSlickGallery, 300);
 });
 document.addEventListener("shopify:page:load", function () {
   setTimeout(initSlickGallery, 300);
 });
 
 document.addEventListener("clearFiltering", function () {
   if ($(window).width() < 769) {
     $(".product-v2--gallery-grid").slick("slickUnfilter");
   }
 });
 
 document.addEventListener("SetImagesFired", function () {
   if ($(window).width() < 769) {
     $(".product-v2--gallery-grid").slick("slickFilter", ":not(.disabled-item)");
     $(".product-v2--gallery-grid").slick("setPosition");
   }
 });
 
 $(document).on("click", ".product-v2--grid-item a[data-slide]", function (e) {
   e.preventDefault();
   $(".product-v2--gallery-grid").slick("slickGoTo", -1);
 });
 


$(document).ready(function () {
  
   function customDots(){
      setTimeout(function() {
         $('.custom-dot li button').each(function(index) {
            var $img = $('.product-v2--gallery-grid-rebuild .slick-track div:eq(' + index + ') img');
            var imageUrl = $img.attr('src').replace(/1100/g, "150");
            
            if (imageUrl.includes("generic-lazy-load-WHITE")) {
               customDots(); 
               return false;
            }

            $(this).css({
               'background-image': 'url(' + imageUrl + ')',
               'background-position': 'center',
               'background-repeat': 'no-repeat'
            });
         });
      }, 100);
   }

   $(".product-v2--gallery-grid-rebuild").on('init', function (event, slick, direction) {
      slick.slickFilter(':not(.disabled-item)');
   }).slick({
      dots: true,
      arrows: true,     
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      infinite: true,
      appendDots: $('.product-v2--gallery-selector'),
      dotsClass: 'custom-dot',
      fade: false, 
      responsive: [
         {
            breakpoint: 768, 
            settings: {
               fade: true,
            }
         }
      ]
   }).on('afterChange', (slick, currentSlide) => {
      const video = currentSlide.$slider.find('video').get(0);
      if (video) {
         video.play();
      }
   });

   document.addEventListener('clearFiltering', function (e) {
         $(".product-v2--gallery-grid-rebuild").slick('slickUnfilter');
   });

   document.addEventListener('SetImagesFired', function (e) {
      // console.log('responsive mobile', $(window).width());
      // console.log('css classes where changed');
     
         //console.log('filtering');
         $(".product-v2--gallery-grid-rebuild").slick('slickFilter', ':not(.disabled-item)');
         $(".product-v2--gallery-grid-rebuild").slick('setPosition');
         $(".product-v2--gallery-grid-rebuild").slick('slickGoTo', 0);
         customDots();
    
   }, false);

});

/* Product image gallery responsive */

$(document).ready(function () {
   $(".gallery__modal--carousel").slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      infinite: false,
      prevArrow: $(".gallery-carousel__prev"),
      nextArrow: $(".gallery-carousel__next")
   }).on('afterChange', (slick, currentSlide) => {
      const video = currentSlide.$slider.find('video').get(0);
      if (video) {
         video.play()
      }
   });

});

$(".product-v2--grid-item a[data-slide]").click(function (e) {
   e.preventDefault();
   $(".product-v2--gallery-grid").slick("slickGoTo", -1);
});

/* Reviews from Yotpo */
var yotpoSettings = {
   // sort: 'date',
   sort: 'rating',
   direction: 'desc',
   page: 1,
   last_page: 999,
   per_page: 15,
   productId: null,
}

function toggleReviewSort() {
   let direction = yotpoSettings.direction;
   if (yotpoSettings.direction === 'asc') {
      direction = 'desc';
   }

   if (yotpoSettings.direction === 'desc') {
      direction = 'asc';
   }

   Object.assign(yotpoSettings, {
      direction: direction,
      page: 1
   });

   $('#toggle-reviews-sort').html(`<span>${yotpoSettings.direction === 'asc' ? 'Lowest' : 'Highest'} Rated</span>`);
   updateModalReviews();
}

function formatDate(input) {
   var datePart = input.match(/\d+/g),
      year = datePart[0].substring(2), // get only two digits
      month = datePart[1],
      day = datePart[2];
   return day + "/" + month + "/" + year;
}


/* Modals */

const modalTriggers = Array.from(
   document.querySelectorAll(['[data-toggle="modal"]'])
);

const htmlTag = document.querySelector('html');

document.addEventListener(
   "click",
   (evt) => {
      const element = evt.target;
      if (modalTriggers.includes(element)) {
         const selector = element.getAttribute("data-target");
         const targetElement = document.querySelector(selector);

         if (htmlTag.classList.contains('no-scroll')) {
            bodyScrollLock.clearAllBodyScrollLocks();
         } else {
            bodyScrollLock.disableBodyScroll(targetElement);
         }
         htmlTag.classList.toggle('no-scroll');

         // check if is gallery modal
         if (element.hasAttribute('data-slide-index')) {
            let imageIndex = element.getAttribute('data-slide-index');
            manageModal(selector, "toggle", imageIndex);
         } else {
            manageModal(selector, "toggle", '');
         }

      }
   },
   false
);

const modalmap = {
   toggle: "toggle",
   active: "add",
   hide: "remove",
};

// 2/9/23 old: //cdn.shopify.com/s/files/1/2513/7040/t/327/assets/icon-star-full.svg?v=17885150460812976143
var yotpoStars = {
    empty: "//cdn.shopify.com/s/files/1/2513/7040/files/icon-star-empty.svg",
   middle: "//cdn.shopify.com/s/files/1/2513/7040/files/icon-star-mid.svg",
   full: "//cdn.shopify.com/s/files/1/2513/7040/files/icon-star-full.svg"
}

const manageModal = (selector, cmd, imageIndex) => {
   const targets = Array.from(document.querySelectorAll(selector));
   document.querySelector('html').classList[modalmap[cmd]]('unscrollable');
   targets.forEach((target) => {
      target.classList[modalmap[cmd]]("active");
      $(".gallery__modal--carousel").slick('slickUnfilter');
      if (imageIndex !== '') {
         $(".gallery__modal--carousel").slick('slickFilter', ':not(.disabled-item)');
         $(".gallery__modal--carousel").slick('setPosition');
         $(".gallery__modal--carousel").slick('slickGoTo', imageIndex, true);
      }
   });
};

const initReviewsSlider = (container, response) => {
   let reviews = response.reviews;
   // console.log("reviews", reviews);
   let total_review = response.bottomline.total_review;
   let average_score = response.bottomline.average_score;
   let sizing = response.bottomline.custom_fields_bottomline
      ? response.bottomline.custom_fields_bottomline['--43945']
      : undefined;

   if (!sizing) {
      sizing = { average_score: 2, score: 2, type: 'Size', title: 'Product Sizing' };
   }

   let stars = "";
   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }

   if (reviews.length > 0) {
      container.append(`
      <div class="product-v2--reviews-item">
      	<div class="product-v2--reviews-summary">
             
              <p class="reviews-item--score roboto-mono-bold"><span itemprop="ratingValue">${average_score.toFixed(1)}</span></p>
              <div class="reviews-item--stars">
                ${stars}
              </div>
              <p class="reviews-item--rating">Overall rating based on <span itemprop="ratingCount">${total_review}</span> reviews</p>
              <p class="reviews-item--product-type roboto-mono-bold">Standard Fit</p>
              <div class="reviews__fit--indicator reviews__fit--indicator-v2">
                  <div class="fit__indicator" style="left: ${(sizing.average_score - 1) * 50}%; transform: translate(-${sizing.average_score === 1 ? '0%' : (sizing.average_score === 3 ? '100%' : '50%')}, -50%);"></div>
                  <div class="fit__indicators">
                      <span>Runs Small</span>
                      <span>Runs Big</span>
                  </div>
              </div>
              <a href="#write" id="write-review" style="display:block" class="reviews-item--btn" data-toggle="collapse" data-target=".collapse.write" data-text="Collapse">Write a Review</a>
			
      	</div>
      </div>
    `);
   }

   if (reviews.length === 0) {
      container.append(`
      <div class="product-v2--reviews-item h-auto product-v2--reviews-item-no-reviews">
        <div class="product-v2--reviews-summary-no-reviews">
        <p class="reviews-item--rating">There aren't reviews in this product yet.</p>
        <a href="#write" id="write-review" class="reviews-item--btn" data-toggle="collapse" data-target=".collapse.write" data-text="Collapse">Write a Review</a>
        </div>
      </div>
    `);

      $(".product-v2--reviews-footer").hide();
      $("#review-carousel").removeClass("product-v2--reviews-carousel");
      $(".review-carousel__arrows").remove();
      $(".product-v2--reviews").css('position', 'relative');
      $(".product-v2--reviews-header p").remove();
      $(".product-v2--reviews-header").css('padding', '20px 0px 5px 0px');
   }

   $.each(reviews, function (index, review) {
      createReviewSlide(container, review);
      createModalReviewItem($(".modal-reviews--container"), review);
   });

   $(".product-v2--reviews-carousel").slick({
      adaptiveHeight: true,
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: "0",
      infinite: false,
      prevArrow: $(".product-v2--reviews-header .review-carousel__prev"),
      nextArrow: $(".product-v2--reviews-header .review-carousel__next"),
      responsive: [
         {
            breakpoint: 1024,
            settings: {
               slidesToShow: 2.5,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 900,
            settings: {
               slidesToShow: 2.5,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 550,
            settings: {
               slidesToShow: 2.1,
               slidesToScroll: 1,
            },
         },
      ],
   });
}

const initReviewsSliderRebuild = (container, response, containerItems) => {
   let reviews = response.reviews;
   // console.log("reviews", reviews);
   let total_review = response.bottomline.total_review;
   let average_score = response.bottomline.average_score;
   let sizing = response.bottomline.custom_fields_bottomline
      ? response.bottomline.custom_fields_bottomline['--43945']
      : undefined;

   if (!sizing) {
      sizing = { average_score: 2, score: 2, type: 'Size', title: 'Product Sizing' };
   }

   let stars = "";
   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }

   if (reviews.length > 0) {
      container.append(`
      <div class="product-v2--reviews-item item-main-review">
         <div class="product-v2--reviews-summary">
               
               <p class="reviews-item--score roboto-mono-bold"><span itemprop="ratingValue">${average_score.toFixed(1)}</span></p>
               <div class="reviews-item--stars">
                  ${stars}
               </div>
               <p class="reviews-item--rating">${total_review} REVIEWS</p>
         </div>
      </div>
  `);
   }

   if (reviews.length === 0) {
      container.append(`
      <div class="product-v2--reviews-item h-auto product-v2--reviews-item-no-reviews">
        <div class="product-v2--reviews-summary-no-reviews">
        <p class="reviews-item--rating">There aren't reviews in this product yet.</p>
        <a href="#write" id="write-review" class="reviews-item--btn" data-toggle="collapse" data-target=".collapse.write" data-text="Collapse">Write a Review</a>
        </div>
      </div>
    `);

      $(".product-v2--reviews-footer-rebuild").hide();
      $("#review-carousel-rebuild").removeClass("product-v2--reviews-carousel");
      $(".review-carousel__arrows-rebuild").remove();
      $(".product-v2--reviews").css('position', 'relative');
      $(".product-v2--reviews-header-rebuild p").remove();
      $(".product-v2--reviews-header-rebuild").css('padding', '20px 0px 5px 0px');
   }

   $.each(reviews, function (index, review) {
      createReviewSlideRebuild(container, review, containerItems);
      createModalReviewItem($(".modal-reviews--container"), review);
   });

   $(".product-v2--reviews-carousel-rebuild-items").slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: "0",
      infinite: true,
      responsive: [
         {
            breakpoint: 1024,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 900,
            settings: {
               adaptiveHeight: true,
               slidesToShow: 2,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 550,
            settings: {
               adaptiveHeight: true,
               slidesToShow: 1,
               slidesToScroll: 1,
            },
         },
      ],
   });

}

const renderReviewsSummary = (summary) => {
   var container = $(".product-v2--review-count");

   let stars = "";
   let average_score = summary.average_score;
   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }

   container.prepend(`
    <div class="product-v2--review-summary">
      ${stars}

      <a href="#product-v2--reviews">(${summary.total_review} ${summary.total_review > 1 ? 'reviews' : 'review'})</a>
    </div>
  `);
}

const renderReviewsSummaryRebuild = (summary) => {
   var container = $(".product-v2--review-count-rebuild");

   let stars = "";
   let average_score = summary.average_score;
   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }


   if (summary.total_review > 0) {
      container.prepend(`
         <div class="product-v2--review-summary">
            ${stars}
            <a class="btn-reviewCount" href="#product-v2--reviews">(${summary.total_review} ${summary.total_review > 1 ? 'reviews' : 'review'})</a>
         </div>
      `);
   }  

   $(document).ready(function() {
      $(document).on('click', '.product-v2--reviews-summary .reviews-item--rating', function() {
          $('#review--all').addClass('active');
          $('html').addClass('no-scroll');
          $('html').addClass('unscrollable');
      });
  });
  
}

const renderCollectionReviewsSummary = (summary, data) => {
   var container = $(`.product-v2--review-count-plp-${data.id}`);
   let stars = "";
   let average_score = summary.average_score;
   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }

   // don't output anything if no reviews
   if (summary.total_review > 0) {
      container.prepend(`
          <div class="product-v2--review-summary-${data.id} product-v2--review-summary-img">
              <a href="${data.url}">
                  ${stars} (${summary.total_review} ${summary.total_review == 1 ? 'review' : 'reviews'})
              </a>
          </div>
      `);
   }

}

const updateModalReviews = () => {
   const container = $(".modal-reviews--container");

   if (yotpoSettings.page === 1) {
      // clear the container if its empty
      $(".modal-reviews--container").html('');
   }

   fetchReviews(function (data) {
      let reviews = data.response.reviews;

      Object.assign(yotpoSettings, {
         last_page: Math.ceil(data.response.pagination.total / data.response.pagination.per_page)
      });

      $.each(reviews, function (index, review) {
         createModalReviewItem(container, review);
      });
   });

}

const fillReviewModal = (data) => {
   let total_reviews = data.response.bottomline.total_review;
   let average_score = data.response.bottomline.average_score;
   let sizing = data.response.bottomline.custom_fields_bottomline
      ? data.response.bottomline.custom_fields_bottomline['--43945']
      : undefined;

   if (!sizing) {
      sizing = { average_score: 2, score: 2, type: 'Size', title: 'Product Sizing' };
   }

   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));
   let stars = "";

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }

   $("#reviews-modal--stars").append(stars);
   $(".fit__indicator--modal").css("left", `${(sizing.average_score - 1) * 33.33}%`);
   $("#reviews__modal--rating").text(`Overall rating based on ${total_reviews} reviews`);
}

const fillReviewModalRebuild = (data) => {
   let total_reviews = data.response.bottomline.total_review;
   let average_score = data.response.bottomline.average_score;
   let sizing = data.response.bottomline.custom_fields_bottomline
      ? data.response.bottomline.custom_fields_bottomline['--43945']
      : undefined;

   if (!sizing) {
      sizing = { average_score: 2, score: 2, type: 'Size', title: 'Product Sizing' };
   }

   let fullStars = Math.floor(average_score);
   let middleStars = (Math.ceil(average_score) - Math.floor(average_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(average_score));
   let stars = "";

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="20"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="20"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="20"/>`;
   }

   $("#reviews-modal--starsRebuild").append(stars);
   $(".fit__indicator--modal").css("left", `${(sizing.average_score - 1) * 33.33}%`);
   $("#reviews__modal--rating").text(`Overall rating based on ${total_reviews} reviews`);
}

const createReviewSlide = (container, review) => {
   let review_id = review.id;
   let review_score = review.score;
   let review_date = review.created_at.split("T")[0]; // don't care about the H:M:SSTZ
   let preview_words = 30;
   let snippet_length = preview_words; // # words of review to show
   let review_arr = review.content.split(" "); // split review up into words
   let more_str = "";

   if (review_arr.length < snippet_length) {
      snippet_length = review_arr.length;
   } // set preview_length to smallest of supplied value or length of review array

   let review_text = "";
   for (let x = 0; x < snippet_length; x++) {
      // build up preview snippet so we can break on whole words
      review_text += review_arr[x] + " "; // with space after each word
   }

   let stars = "";
   let fullStars = Math.floor(review_score);
   let middleStars = (Math.ceil(review_score) - Math.floor(review_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(review_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="14"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="14"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="14"/>`;
   }

   if (review_arr.length > preview_words) {
      more_str = "...";
   }
   // console.log(`review_id: ${review_id}`);
   container.append(`
    <div class="product-v2--reviews-item">
      <div class="product-v2--review-container">
        <span class="reviews-item--icon roboto-mono-bold">“</span>
        <p class="reviews-item--title roboto-mono-bold">${review.title}.</p>
        <div class="reviews-item--quote">
          <p>${review_text}${more_str}</p>
        </div>
        <div class="reviews-item--meta">
          <div class="reviews-item--author">
            <div class="reviews-item--stars">
              ${stars}
            </div>
            <p>${review.user.display_name}</p>
          </div>
          <div class="reviews-item--date">
            <p>${formatDate(review_date)}</p>
          </div>
        </div>
      </div>
    </div>
  `);
   //var $row = $('<a></a>').attr('href', product_page_link + item.handle);
   //$row.append('<div class="img"><img src="' + item.images_info[0].src.replace(".jpg", "_large.jpg") + '" alt="' + item.images_info[0].alt + '" + /></div>');
   //$resultsBox.append($row);
}

const createReviewSlideRebuild = (container, review, containerItems) => {
   let review_id = review.id;
   let review_score = review.score;
   let review_date = review.created_at.split("T")[0]; // don't care about the H:M:SSTZ
   let preview_words = 30;
   let snippet_length = preview_words; // # words of review to show
   let review_arr = review.content.split(" "); // split review up into words
   let more_str = "";

   if (review_arr.length < snippet_length) {
      snippet_length = review_arr.length;
   } // set preview_length to smallest of supplied value or length of review array

   let review_text = "";
   for (let x = 0; x < snippet_length; x++) {
      // build up preview snippet so we can break on whole words
      review_text += review_arr[x] + " "; // with space after each word
   }

   let stars = "";
   let fullStars = Math.floor(review_score);
   let middleStars = (Math.ceil(review_score) - Math.floor(review_score)) > 0 ? 1 : 0;
   let emptyStars = (5 - Math.ceil(review_score));

   for (let s = 0; s < fullStars; s++) {
      stars += `<img src="${yotpoStars.full}" height="14"/>`;
   }

   for (let s = 0; s < middleStars; s++) {
      stars += `<img src="${yotpoStars.middle}" height="14"/>`;
   }

   for (let s = 0; s < emptyStars; s++) {
      stars += `<img src="${yotpoStars.empty}" height="14"/>`;
   }

   if (review_arr.length > preview_words) {
      more_str = "...";
   }
   // console.log(`review_id: ${review_id}`);
   containerItems.append(`
    <div class="product-v2--reviews-item item-review">
      <div class="product-v2--review-container">
         <div class="reviews-item--meta">
         <div class="reviews-item--author">
            <div class="reviews-item--stars">
               ${stars}
            </div>
            <span>|</span>
            <p>${review.user.display_name}</p>
         </div>
         </div>
         <p class="reviews-item--title roboto-mono-bold">${review.title}.</p>
         <div class="reviews-item--quote">
            <p>${review_text}${more_str}</p>
         </div>
         </div>
      </div>
   `);
   //var $row = $('<a></a>').attr('href', product_page_link + item.handle);
   //$row.append('<div class="img"><img src="' + item.images_info[0].src.replace(".jpg", "_large.jpg") + '" alt="' + item.images_info[0].alt + '" + /></div>');
   //$resultsBox.append($row);
}

const createModalReviewItem = (container, review) => {
   let review_id = review.id;
   let stars;
   let review_score = review.score;
   let review_date = review.created_at.split("T")[0]; // don't care about the H:M:SSTZ
   let preview_words = 50;
   let snippet_length = preview_words; // # words of review to show
   let review_arr = review.content.split(" "); // split review up into words
   let more_str = "";
   let sizing = review.custom_fields
      ? review.custom_fields['--43945']
      : { value: 3, type: 'Size', title: 'Product Sizing' }

   let review_text = review_arr.join(" ");

   const sizingLabels = {
      1: "It Runs Small",
      2: "It Fits Just Right",
      3: "It Runs Big"
   };
   
   const labelLocationMapping = {
      1: "fit__indicator_label-left",
      2: "fit__indicator_label-center",
      3: "fit__indicator_label-right"
   };
   
   
   const defaultLabel = "Fits Just Right";
   const defaultLabelLocation = "fit__indicator_label-left";
   
   const sizingLabel = sizingLabels[sizing.value] || defaultLabel;
   const labelLocation = labelLocationMapping[sizing.value] || defaultLabelLocation;
   

   stars = ""; // reset for each review
   for (let s = 0; s < review_score; s++) {
      stars += `<img src="//cdn.shopify.com/s/files/1/0278/5443/8475/t/120/assets/icon-star.svg" height="20"/>`; // TODO: fix the url in production
   }

   if (review_arr.length > preview_words) {
      more_str = "...";
   }
   // console.log(`review_id: ${review_id}`);
   container.append(`
    <div class="reviews__item--container">
      <div class="reviews-item--stars">
        ${stars}
      </div>
      <p class="reviews-item--title roboto-mono-bold">${review.title}.</p>
      <p class="fit__indicator_label ${labelLocation}">${sizingLabel}</p>
      <div class="reviews__fit--indicator">
        <div class="fit__indicator" style="left: ${(sizing.value - 1) * 33.33}%;"></div>
      </div>
      <div class="reviews-modal--quote">
        <p>${review_text}</p>
      </div>
      <div class="reviews-modal--meta">
        <div class="reviews-modal--author">
          <p>${review.user.display_name}</p>
        </div>
        <div class="reviews-modal--date">
            <p>${formatDate(review_date)}</p>
        </div>
      </div>
    </div>
  `);
   //var $row = $('<a></a>').attr('href', product_page_link + item.handle);
   //$row.append('<div class="img"><img src="' + item.images_info[0].src.replace(".jpg", "_large.jpg") + '" alt="' + item.images_info[0].alt + '" + /></div>');
   //$resultsBox.append($row);
}

const fetchReviews = (callback, error) => {
   $.ajax({
      url: `https://api.yotpo.com/v1/widget/NuCBdWmL7wbp5ZMCg5wkVqf8LCFcKtpudpSpnV35/products/${yotpoSettings.productId}/reviews.json?per_page=${yotpoSettings.per_page}&page=${yotpoSettings.page}&sort=${yotpoSettings.sort}&direction=${yotpoSettings.direction}`,
      dataType: "json",
      success: function (data) {
         callback && callback(data);
      },
      error: function (XMLHttpRequest) {
         var response = eval("(" + XMLHttpRequest.responseText + ")");
         response = response.description;
         // console.log(`Yotpo error: ${response}`);
         error && error(XMLHttpRequest);
      },
   });
}

const fetchReviewsPLP = (product_id, callback, error) => {
   $.ajax({
      url: `https://api.yotpo.com/v1/widget/NuCBdWmL7wbp5ZMCg5wkVqf8LCFcKtpudpSpnV35/products/${product_id}/reviews.json?per_page=1&page=1`,
      dataType: "json",
      success: function (yotpo_data) {
         //console.log(`yotpo ajax call for product_id ${product_id}: ${JSON.stringify(yotpo_data)}`);
         callback && callback(yotpo_data);
      },
      error: function (XMLHttpRequest) {
         var response = eval("(" + XMLHttpRequest.responseText + ")");
         //response = response.description;
         // console.log(`Yotpo error: ${response}`);
         error && error(XMLHttpRequest);
      },
   });
}

const storeReviewData = (data, callback, error) => {
   $.ajax({
      url: `https://api.yotpo.com/v1/widget/reviews`,
      contentType: "application/json",
      dataType: "json",
      method: "POST",
      data: JSON.stringify(data),
      success: function (response) {
         callback && callback(response);
      },
      error: function (XMLHttpRequest) {
         var response = eval("(" + XMLHttpRequest.responseText + ")");
         response = response.description;
         // console.log(`Yotpo error: ${response}`);
         error && error(XMLHttpRequest);
      },
   });
}

const submitQuestion = (data, callback, error) => {
   $.ajax({
      url: `https://api.yotpo.com/questions/send_confirmation_mail`,
      contentType: "application/json",
      dataType: "json",
      method: "POST",
      data: JSON.stringify(data),
      success: function (response) {
         callback && callback(response);
      },
      error: function (XMLHttpRequest) {
         var response = eval("(" + XMLHttpRequest.responseText + ")");
         response = response.description;
         // console.log(`Yotpo error: ${response}`);
         error && error(XMLHttpRequest);
      },
   });
}

const closeModalReview = document.getElementById("review--all");
const close = document.getElementById("reviews-btn-close");

close.onclick = function (event) {
   event.preventDefault();
   htmlTag.classList.remove('no-scroll');
   bodyScrollLock.clearAllBodyScrollLocks();
   closeModalReview.classList.remove("active");
   document.querySelector('html').classList.remove('unscrollable');
   $('#question').removeClass('show');
   $('#write').addClass('show');
   $('html, body').animate({
      scrollTop: $('#reviews-form-section').offset().top - 90
   }, 1000);
};

/* End */

/* Btn write review */
const reviewCarousel = document.getElementById("review-carousel-rebuild");

if (reviewCarousel !== null) {
   reviewCarousel.addEventListener("click", function (e) {
      e.preventDefault();
      if (e.target && e.target.matches("a.reviews-item--btn")) {
         const writeReview = document.getElementById("write");
         writeReview.classList.toggle("show");
      }
   });
}

/* End */

$(document).on('click', '#write-review', function (e) {
   e.preventDefault();

   const target = this.hash;
   const $target = $(target)

   $('html, body').stop().animate({
      'scrollTop': $target.offset().top
   }, 600, 'swing', function () {
      //window.location.hash = target;
   })

})

/**
 * Fit Finder Overrides
 * we are overriding the fit finder toggler, so let's listend for clicks to open the fit finder modal
 */
$(document).ready(function () {
   var waitForAnalytics = function (callback) {
      var interval = setInterval(function () {
         if (window._fitAnalytics && window._fitAnalytics.shop) {
            clearInterval(interval);
            callback();
            return;
         }
      }, 1000);
   }

   waitForAnalytics(function () {
      $(document).on('click', '#fitanalytics__button', function () {
         window._fitAnalytics.widget.meterClick("sizeAdvisor");
         window._fitAnalytics.widget.open({
            productId: window._fitAnalytics.shop.getCurrentSerial(),
            thumb: window._fitAnalytics.shop.getThumbnail(),
            size: window._fitAnalytics.shop.getSizes()
         });
      });
   });
});

// // Find the container that will hold the recommendations
// var list = document.querySelector(".product-v2--like-carousel");

// // Get the base URL for translated product recommendations
// var baseUrl = list.dataset.baseUrl;

// // Get the product ID to request the product recommendations
// var productId = list.dataset.productId;

// // Create an AJAX request
// var request = new XMLHttpRequest();

// request.open("GET", baseUrl + ".json?product_id=" + productId + "&limit=4");

// request.onload = function () {
//   if (request.status === 404 || request.status === 422) {
//     return hideRecommendationsSection();
//   }

//   var products = JSON.parse(request.response).products;

//   if (products.length === 0) {
//     return hideRecommendationsSection();
//   }

//   // Append product recommendations to the DOM.
//   list.innerHTML = products
//     .map(function (product) {
//       return renderProduct(product);
//     })
//     .join("");
// };

// request.onerror = function () {
//   hideRecommendationsSection();
// };

// // Send AJAX request
// request.send();

// function hideRecommendationsSection() {
//   list.style.display = "none";
// }

// function renderProduct(product) {
//   return [
//     '<div class="grid__item medium-up--one-quarter text-center recommendation-col">', // <div> // <div class="grid__item medium-up--one-quarter text-center">
//     '<a href="' + product.url + '" class="product__anchor">',
//     '<img class="recommendation__img" src="' +
//       product.featured_image +
//       '" alt="' +
//       product.title +
//       '"/>',
//     "<br>",
//     '<span class="product__title">' + product.title + "</span>",
//     "<br>",
//     //'<p class="product__price">' + formatMoney(product.price, window.moneyFormat) + '</p>',
//     '<span class="product__price">' +
//       formatMoney(product.price, window.moneyFormat) +
//       "</span>",
//     "</a>",
//     "</div>",
//   ].join("");
// }

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */



/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {

   const moneyFormat = "${{amount}}";
   if (typeof cents === "string") {
      cents = cents.replace(".", "");
   }
   let value = "";
   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
   const formatString = format || moneyFormat;

   switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
         value = formatWithDelimiters(cents, 2);
         break;
      case "amount_no_decimals":
         value = formatWithDelimiters(cents, 0);
         break;
      case "amount_with_comma_separator":
         value = formatWithDelimiters(cents, 2, ".", ",");
         break;
      case "amount_no_decimals_with_comma_separator":
         value = formatWithDelimiters(cents, 0, ".", ",");
         break;
   }

   return formatString.replace(placeholderRegex, value);
}

function formatWithDelimiters(
   number,
   precision = 2,
   thousands = ",",
   decimal = "."
) {
   if (isNaN(number) || number == null) {
      return 0;
   }

   number = (number / 100.0).toFixed(precision);

   const parts = number.split(".");
   const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
   );
   const centsAmount = parts[1] ? decimal + parts[1] : "";

   return dollarsAmount + centsAmount;
}

/* Toogle */
const sizeSwitch = document.getElementById("input-size-switch");
const inchLabel = document.getElementById("inchLabel");
const cmLabel = document.getElementById("cmLabel");

sizeSwitch.addEventListener("click", checkMode);

function checkMode() {

   const cellValues = document.querySelectorAll(".measure__table_td");

   if (sizeSwitch.checked) {

      inchLabel.classList.remove('active');
      cmLabel.classList.add('active');

      cellValues.forEach((cell) => {
         let value = cell.innerHTML.trim().replace(/&nbsp;/g, '');
         let numbers = value.split("-");
         let convertedNumbers = [];

         for (let index = 0; index < numbers.length; index++) {
            let number = parseFloat(numbers[index]);
            let convertedNumber = number * 2.54;
            convertedNumber = convertedNumber.toFixed(2);
            convertedNumbers.push(convertedNumber);
         }
         let html = convertedNumbers.join('-');
         cell.innerHTML = html;
      });

   } else {
      inchLabel.classList.add('active');
      cmLabel.classList.remove('active');

      cellValues.forEach((cell) => {
         let value = cell.innerHTML.trim().replace(/&nbsp;/g, '');
         let numbers = value.split("-");
         let convertedNumbers = [];

         for (let index = 0; index < numbers.length; index++) {
            let number = parseFloat(numbers[index]);
            let convertedNumber = number * 0.39370079;
            convertedNumber = convertedNumber.toFixed(1);
            convertedNumbers.push(convertedNumber);
         }
         let html = convertedNumbers.join('-');
         html = html.split(".0").join("");
         cell.innerHTML = html;
      });

   }
}
